module.exports = __webpack_public_path__ + "static/banner-tablet-82dc2615f2e360c452a080dba3caad5a.png";